import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';

const WordpressSEO = ({ data, children }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `,
  );

  const seo = data?.seo;

  let canonicalUrl = '',
    ogTitle = '',
    ogDescr = '',
    ogType = '',
    ogLocale = '';

  if (seo?.opengraphTitle) {
    ogTitle = <meta property="og:title" content={seo.opengraphTitle} />;
  }

  if (seo?.opengraphDescription) {
    ogDescr = <meta property="og:description" content={seo.opengraphDescription} />;
  }

  if (seo?.opengraphType) {
    ogType = <meta property="og:type" content={seo.opengraphType} />;
  }

  if (seo?.canonical) {
    let initialCanonicalURL = seo?.canonical;
    // If it's a relative path, append the complete hostname.
    if (initialCanonicalURL.indexOf('hometap.com') === -1) {
      initialCanonicalURL = 'https://www.hometap.com' + initialCanonicalURL;
    }
    // If it's a valid URL, but isn't correctly formatted.
    else if (
      initialCanonicalURL.indexOf('https://www.hometap.com') === -1 &&
      initialCanonicalURL.indexOf('hometap.com') !== -1
    ) {
      initialCanonicalURL = initialCanonicalURL.split('hometap.com')[1];
      initialCanonicalURL = 'https://www.hometap.com' + initialCanonicalURL;
    }

    // Ensure there's a trailing slash, for consistency.
    if (initialCanonicalURL.slice(-1) !== '/') initialCanonicalURL += '/';
    canonicalUrl = <link rel="canonical" href={initialCanonicalURL} />;
  }

  return (
    <div>
      <Helmet
        htmlAttributes={{
          lang: 'en',
        }}
      >
        <title>{seo?.title || site.siteMetadata.title}</title>
        <meta
          name="description"
          content={seo?.metaDesc || seo?.opengraphDescription || site.siteMetadata.description}
        ></meta>
        <meta property="og:locale" content="en_US" />
        {canonicalUrl}
        {ogTitle}
        {ogDescr}
        {ogType}
        {ogLocale}
        <meta property="og:image" content={seo?.opengraphImage?.sourceUrl || data?.featuredImage?.node?.sourceUrl} />
      </Helmet>
      {children}
    </div>
  );
};

export default WordpressSEO;
